export default {
  page: 'Page',
  layoutSubtitle: 'Settings left empty are taken from the base layout.',
  blocksSubtitle: 'Blocks appear in the report in this order. Drag a block by its handle to move it.',
  resetBlocks: 'Use the default blocks of the report',
};
